"use client";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import Image from "next/image";
import Link from "next/link";
import { TOCInlineProps } from "@/data/types";

// Type definition for Table of Contents
export type Toc = {
  value: string;
  depth: number;
  url: string;
}[];

// ✅ Automatically Assign IDs to MDX Headings
export const useMDXHeadings = () => {
  useEffect(() => {
    const headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

    headings.forEach((heading) => {
      if (!heading.id) {
        const text = heading.textContent?.trim() || "";
        const id = text
          .toLowerCase()
          .replace(/\s+/g, "-") // Convert spaces to hyphens
          .replace(/[^\w-]+/g, ""); // Remove special characters

        heading.id = id; // Assign generated ID
      }
    });
  }, []);
};

export const ContentGrid = ({
  toc,
  indentDepth = 3,
  fromHeading = 1,
  toHeading = 6,
  asDisclosure = false,
  exclude = "",
  defaultimage = '',
  slug,
}: TOCInlineProps) => {
  const router = useRouter();
  useMDXHeadings(); // ✅ Assign IDs to headings when MDX is rendered

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true); // Ensures TOC is rendered only on the client
  }, []);

  // ✅ Filter headings based on depth and exclude patterns
  const filteredToc = toc.filter(
    (heading) =>
      heading.depth >= fromHeading &&
      heading.depth <= toHeading &&
      !new RegExp(`^(${exclude})$`, "i").test(heading.value)
  );

  // ✅ Smooth Scrolling Navigation
  const handleNavigation = (e: React.MouseEvent<HTMLAnchorElement>, url: string) => {
    e.preventDefault();
    const target = document.getElementById(url);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      window.history.pushState(null, "", `#${url}`);
    }
  };

  // ✅ Generate Table of Contents
  const tocList = (
    <div className="space-y-6 gap-x-5">
      <div className="fixed left-0 top-0 h-full w-64 overflow-y-auto bg-white shadow-md">
        <ol className="list-decimal pl-9">
          {isClient &&
            filteredToc.map((heading) => (
              <li
                key={`${heading.url}-${heading.depth}`}
                className={`hover:text-blue-600 ${heading.depth >= indentDepth ? "ml-6" : ""
                  }`}
              >
                <a
                  href={heading.url}
                  onClick={(e) => handleNavigation(e, heading.url)}
                  className="text-gray-700 no-underline hover:text-rose-500"
                  style={{ textDecoration: "none" }}
                >
                  {heading.value}
                </a>
              </li>
            ))}
        </ol>
      </div>

    </div>
  );

  return (
    <div className="">
      {/* <div className="row gap-1 justify-center items-center text-center">
        <div className="col-md-7   border border-solid border-indigo-600 inline-block">Content 1</div>
        <div className="col-md-4  border border-solid border-indigo-600 inline-block">Content 2</div>
      </div> */}
        {/* <div className="flex justify-center items-center"> */}
      <div className="blog-media mb-40 mb-xs-30 mt-60">
        <Image
          src={process.env.NEXT_PUBLIC_BASE_URL + defaultimage}
          style={{borderRadius: "30px" , boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)"}}
          alt={slug || 'Default Image Description'}
          width={1200}
          height={400}
        />
      </div>

      <h2>Table Content</h2>
      {!asDisclosure && tocList}

      {/* <section className="">
        <div className="container position-relative">
          <div className="row">
            <div className="col-md-8 pt-sm-0">

              {!asDisclosure && tocList}

            </div>
            <div className="col-md-3 mb-md-50 mb-sm-30 text-center">
              <p className="mb-30" style={{ color: "#0044cc" }}>
                We are here to help you find a solution that suits your business need.
              </p>
              <div className="d-flex justify-content-center">
                <Link href={"/"}>
                  <button
                    type="submit"
                    aria-controls="subscribe-result"
                    className='btn btn-mod btn-large btn-round btn-hover-anim'
                    style={{ border: "1px solid black", }}
                  >
                    <span>Book Demo</span>
                  </button>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section> */}

    </div>

  );
};

export default ContentGrid;